export default "__VITE_ASSET__CbwCZE_Q__"